module.exports = __webpack_public_path__ + "img/大数据平台数据仓库.d3dfeec1.jpg";